import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { autobind } from 'core-decorators';
import { noop } from '@src/utils/common-util';
import InputStore from '@src/pages/main/components/appointment-modal/components/input/store';
import { useEffect } from 'react';
import { useCountDown, useUnmount } from 'ahooks';

import { isIOS } from 'detect-mobile-device';
import * as Scroll from 'react-scroll';
import Service from '../service';

import { useRequest } from 'ahooks';
import lockAsync from '@src/utils/lock-async';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import getUtmSource from '@src/utils/get-utm-source';
// import AntdMessage from '@src/components/antd/message';
import Toast from '@src/components/toast';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import { $$tracker } from '@src/tracker';

/**
 * 预约类型
 * @type {{PC: number, 主机: number}}
 */
export const APPOINTMENT_TYPE = {
  PC: 1,
  主机: 2
};

class AppointmentModalStore {
  onClose = noop;
  /**
   * 是否预约成功
   * @type {boolean}
   */
  @observable isAppointmentSuccess = false;

  // 是否是新预约
  @observable is_new = false;

  /**
   * 协议抖动
   * @type {boolean}
   */
  @observable protocolShaking = false;
  /**
   * 弹窗是否打开
   * @type {boolean}
   */
  @observable isOpen = false;
  /**
   * 当前选择的预约类型
   * @type {number}
   */
  @observable currentAppointmentType = APPOINTMENT_TYPE.PC;
  /**
   * 是否已经同意协议
   * @type {boolean}
   */
  @observable isAgreementProtocol = false;

  utmSource = getUtmSource();
  //弹出公共提示弹
  @observable showCommonModal = noop;
  //更新config
  @observable updataConfig = noop;

  @observable startTime = null; //开启记录时间
  @observable endTime = null; // 结束记录时间
  @observable isTimerStarted = false; // 记录是否开始计时
  @observable totalTime = 0; // 总计预约时间

  /**
   * inputStore集合
   * @type {{smsInput: InputStore, emailInput: InputStore}}
   */
  inputStores = {
    emailInput: new InputStore({
      maxLength: 30,
      onBlurToTop: isIOS() ? this.onBlurToTop : '',
      validator: function () {
        if (!this.valueStore.value) {
          this.isError = true;
          this.errorMessage = getLocales('reserve.logic.need_email');
          throw new Error(getLocales('reserve.logic.need_email'));
        }
        if (!/[^A-Za-z0-9\u4e00-\u9fa5 ]/.test(this.valueStore.value)) {
          this.isError = true;
          this.errorMessage = getLocales('reserve.logic.email_format');
          throw new Error(getLocales('reserve.logic.email_format'));
        }
      }
    }),
    smsInput: new InputStore({
      maxLength: 6,
      onBlurToTop: isIOS() ? this.onBlurToTop : '',
      validator: function () {
        if (!this.valueStore.value) {
          this.isError = true;
          this.errorMessage = getLocales('reserve.logic.need_vcode');
          throw new Error(getLocales('reserve.logic.need_vcode'));
        }
      },
      onClick: () => {
        // $$tracker.clickStartCodeInput();
      }
    })
  };
  /**
   * 倒计时关闭时间
   * @type {number}
   */
  @observable countdown = 5;

  constructor(options = {}) {
    // super();
    Object.assign(this, options);
  }

  @autobind
  onSelectAppointmentTypeChange(value) {
    this.currentAppointmentType = value;
  }
  onBlurToTop() {
    Scroll.scroller.scrollTo('index', {
      duration: 0,
      delay: 0,
      smooth: true,
      offset: -50 // Scrolls to element + 50 pixels down the page
    });
  }

  /**
   * 点击关闭时回调
   */
  @autobind
  onCloseHandler() {
    this.isOpen = false;
    this.onClose();
  }

  @autobind
  onAgreeProtocolChange() {
    this.isAgreementProtocol = !this.isAgreementProtocol;
    // $$tracker.clickStartPact();
  }

  /**
   * 提交表单
   */
  @autobind
  async onSubmit() {
    $$tracker.clickLjyy();
    try {
      const _storeArr = Object.keys(this.inputStores);
      _storeArr.forEach(store => {
        this.inputStores[store].validator();
      });
      if (!this.isAgreementProtocol) {
        Toast.info(getLocales('reserve.logic.need_agreement'));
        return;
      }
      const code = this.inputStores.smsInput.valueStore.value;
      const email = this.inputStores.emailInput.valueStore.value;
      const utm_source = '1219DLC';
      const pass_check = 1;

      if (this.startTime) {
        this.endTime = new Date(); // 获取当前时间
        const timeDiff = (this.endTime - this.startTime) / 1000; // 毫秒转为秒
        this.totalTime = timeDiff;
        console.log('经过时间：' + timeDiff + '秒');
      }
      const subscribe_duration_time = this.totalTime;

      const res = await this.submiteRequest.run({ email, code, utm_source, pass_check, subscribe_duration_time });
    } catch (err) {
      // AntdMessage.error(err.message);
    }
  }

  @autobind
  emailInputValidator() {
    this.inputStores.emailInput.validator();
  }

  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    console.log('发送验证码');
    $$tracker.clickYzm();
    try {
      await this.onGetEmailCode.run({ email: this.inputStores.emailInput.valueStore.value, ...authParams, pass_check: 1 });
      return true;
    } catch (err) {
      if (err?.serviceResponse /**属于业务请求异常*/) {
        const { code, msg } = err.serviceResponse;
        // AntdMessage.error(msg);
        Toast.info(msg);
      } else if (err.message) {
        // AntdMessage.error(err.message);
        Toast.info(err.message);
      }
      return false;
    }
  }

  setTargetDate = noop;

  /**
   * 发送邮箱验证码
   * @param params
   * @returns {*}
   */
  onGetEmailCodeAsync = params => {
    return Service.getEmailCode(params);
  };

  /**
   * 预约
   * @param params
   * @returns {*}
   */
  submitAsync = params => {
    return Service.submitAsync(params)
      .then(async res => {
        this.isAppointmentSuccess = true;
        this.is_new = !!res.is_new;
        this.updataConfig(params.email);
        this.setTargetDate(Date.now() + 5000);
        this.clearTimeStyle();
      })
      .catch(err => {
        const { code, msg } = err.serviceResponse;
        // this.showCommonModal('提示', msg);
        // AntdMessage.error(msg);
        Toast.info(msg);
        throw err;
      });
  };

  // 清除预约时间变量
  clearTimeStyle = () => {
    this.startTime = null;
    this.endTime = null;
    this.isTimerStarted = false;
    this.totalTime = 0;
  };

  use() {
    const [countdown, setTargetDate] = useCountDown({ onEnd: this.onCloseHandler });
    /**
     * 获取验证码
     * @type {BaseResult<any, []>}
     */
    this.onGetEmailCode = useRequest(async params => await this.onGetEmailCodeAsync(params), {
      manual: true,
      onSuccess: data => {
        // $$tracker.clickStartCode('success', '');
      },
      onError: e => {
        // $$tracker.clickStartCode('fail', e.serviceResponse?.message);
        e.serviceResponse?.message && Toast.info(e.serviceResponse?.message);
      }
    });
    /**
     * 预约提交
     * @type {BaseResult<any, []>}
     */
    // this.submiteRequest = useRequest(async params => await Service.submitAsync(params), {
    //   manual: true,
    //   throwOnError: true
    // });
    this.submiteRequest = useRequest(async params => await this.submitAsync(params), {
      manual: true,
      throwOnError: true
    });
    this.setTargetDate = setTargetDate;
    useEffect(
      () => {
        this.countdown = countdown;
      },
      [countdown]
    );
    useMount(() => {
      this.isOpen = true;
      this.setTargetDate(undefined);
    });

    // 只有当第一次输入时才启动计时。
    useEffect(
      () => {
        if (this.inputStores.emailInput.valueStore.value && !this.isTimerStarted) {
          this.startTime = new Date(); // 获取当前时间
          console.log('计时开始：' + this.startTime);
          this.isTimerStarted = true;
        }
      },
      [this.inputStores.emailInput.valueStore.value, this.isTimerStarted]
    );

    /**
     * 用于解除协议的抖动动画提示
     */
    useEffect(
      () => {
        if (this.protocolShaking) {
          setTimeout(() => {
            this.protocolShaking = false;
          }, 300);
        }
      },
      [this.protocolShaking]
    );
    useUnmount(() => {
      this.isAppointmentSuccess = false;
      this.inputStores.emailInput.valueStore.value = '';
      this.inputStores.smsInput.valueStore.value = '';
      this.isAgreementProtocol = false;
      this.protocolShaking = false;
      this.clearTimeStyle();
    });
  }
}

export default AppointmentModalStore;
